import React, { Component } from 'react';
import { Header, Segment, Grid, Form, Button, Image, Table, Divider } from "semantic-ui-react"
import ReactSignatureCanvas from 'react-signature-canvas'
import html2canvas from "html2canvas"
import SocOption from './soc_option';
import moment from 'moment';

export default class ScheduleOfConditionsGenerator extends Component {

    constructor(props) {
        super(props);
        this.state = {
            categories:{
                "Flooring": null,
                "Skirting": null,
                "Walls": null,
                "Ceiling": null,
                "Fixtures and Fittings": null,
                "Oven and Grill": null,
                "Washing Machine": null,
                "Kitchen Sink": null,
                "Fridge / Freezer": null,
                "Units and Handles": null,
                "Sanitary Ware": null,
                "Windows Internally": null,
                "Windows Externally": null,
                "Furnishings": null,
                "Miscellaneous": null
            },
            trimmedImage: null,
            generatedSOCImage: null,
            dateOfInspection: "",
            propertyAddress: "",
            inspectionType: "",
            tenantPresent: null,
            initialized: false,
            clearOnResize:false,
        };
        this.sigPad = {}
    }
    componentDidMount() {
        const inspectionTypes = { "inv": "Inventory", "ci": "Check-In", "co": "Check-Out", "inv/ci": "Inventory/Check-In", "pv": "Property Visit" };
        let categoriesArr = [
            "Flooring",
            "Skirting",
            "Walls",
            "Ceiling",
            "Fixtures and Fittings",
            "Oven and Grill",
            "Washing Machine",
            "Kitchen Sink",
            "Fridge / Freezer",
            "Units and Handles",
            "Sanitary Ware",
            "Windows Internally",
            "Windows Externally",
            "Furnishings",
            "Miscellaneous"]
        let categories = {}
        categoriesArr.map((category) => {
          categories[category] = {
            "Cleaned By 3rd Party (Invoice)": { checked: false, comment: null },
            "Clean": { checked: false, comment: null },
            "Further Clean Required": { checked: false, comment: null },
            "Not Clean": { checked: false, comment: null },
            "Not Applicable": { checked: false, comment: null }
          }
        })
        if (this.props.reportDetails) {
            this.setState({
                categories: categories,
                initialized: true,
                propertyAddress: this.props.reportDetails.address,
                dateOfInspection: moment(this.props.reportDetails.inspection_date, "YYYY-MM-DD").format("DD-MM-YYYY"),
                inspectionType: inspectionTypes[this.props.reportDetails.inspection_type]
            })
        }
        else {
            this.setState({ categories: categories, initialized: true })
        }
      }
    render() {
        let canvasClearResizeTrue = async () => {
            this.setState({ clearOnResize: true })
        }
        let canvasClearResizeFalse = async () => {
            this.setState({ clearOnResize:false })
        }
        let canvasClear = async () => {
            this.sigPad.clear()
            await canvasClearResizeTrue()
            window.dispatchEvent(new Event('resize')) 
            await canvasClearResizeFalse()
        }

        let trimImage = () => {
            this.setState({trimmedImage: this.sigPad.getTrimmedCanvas()
                .toDataURL('image/png')})
        }

        let generateSOCImage = async () => {
            this.setState({generatingCanvas:true})
            html2canvas(document.getElementById('domGen'), { backgroundColor: null }).then(canvasObject => { this.setState({ generatedSOCImage: canvasObject.toDataURL('image/png'),generatingCanvas:false });})
        }

        let saveImage = () => {
            const link = document.createElement('a')
        link.download = 'soc_image.png'
        link.href = this.state.generatedSOCImage
        link.click()
        }

        let updateCategory = async (category, updateState) => {
            this.setState({ initialized: false,generatedSOCImage:null })
            let newState = { ...this.state }
            newState.categories[category] = { ...updateState }
            this.setState(...newState)
            this.setState({ initialized: true })
        }
        let categoriesArr = [
            "Flooring",
            "Skirting",
            "Walls",
            "Ceiling",
            "Fixtures and Fittings",
            "Oven and Grill",
            "Washing Machine",
            "Kitchen Sink",
            "Fridge / Freezer",
            "Units and Handles",
            "Sanitary Ware",
            "Windows Internally",
            "Windows Externally",
            "Furnishings",
            "Miscellaneous"]
        let cleanlinessArr = ["Cleaned By 3rd Party (Invoice)", "Clean", "Further Clean Required", "Not Clean", "Not Applicable"]
            let tenantDict = [
                { key: 0, text: "Not Present", value: false },
                { key: 1, text: "Present", value: true }]
        return <Segment  className="pad-top">
            <Form>
                <Grid className="soc-grid" stackable columns={4}>
                    <Grid.Row>
                        <Grid.Column width={16}><Header size='large' textAlign='center' className="icon-button">Schedule of Conditions Image Generator</Header>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}><Divider/><Header size='large' textAlign='center' className="icon-button">General Information</Header>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                    <Grid.Column className="pad-top">
                            <Segment>
                                <Header align="center">Property Address</Header>
                                <Form.Input
                                        placeholder="Property Address"
                                    fluid
                                    value={this.state.propertyAddress}
                                    onChange={(e, option) => {
                                        this.setState({propertyAddress:option.value})}} />
                            </Segment>
                        </Grid.Column>
                        <Grid.Column className="pad-top">
                            <Segment>
                                <Header align="center">Date of Inspection</Header>
                                <Form.Input
                                        placeholder="Date of Inspection"
                                    fluid
                                    value={this.state.dateOfInspection}
                                    onChange={(e, option) => {
                                        this.setState({dateOfInspection:option.value})}} />
                            </Segment>
                        </Grid.Column>
                        <Grid.Column className="pad-top">
                            <Segment>
                                <Header align="center">Type of Inspection</Header>
                                <Form.Input
                                        placeholder="Type of Inspection"
                                    fluid
                                    value={this.state.inspectionType}
                                    onChange={(e, option) => {
                                        this.setState({inspectionType:option.value})}} />
                            </Segment>
                        </Grid.Column>
                        <Grid.Column className="pad-top">
                            <Segment>
                                <Header align="center">Tenant Present?</Header>
                                <Form.Dropdown selection
                                        placeholder="Tenant Present"
                                        fluid
                                        options={tenantDict}
                                    onChange={(e, option) => {
                                        this.setState({tenantPresent:option.value})}} />
                            </Segment>
                        </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                        <Grid.Column width={16}><Divider/><Header size='large' textAlign='center' className="icon-button">Cleanliness</Header>
                        </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                    {categoriesArr.map((category) => {
                        return <Grid.Column key={category} className="pad-top">
                            <Segment>
                                <Header align="center">{category}</Header>
                                <SocOption category={category} updateCategory={updateCategory}/>                           
                            </Segment>
                        </Grid.Column>
                    })}
                    </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={16}>
                            <Segment>
                                <Header align="center">Additional Comments</Header>
                                <Form.TextArea onChange={(e) => {this.setState({additionalComments:e.target.value})}} />
                                </Segment>
                                </Grid.Column>
                    </Grid.Row>
                     <Grid.Row>
                        <Grid.Column width={16}>
                            <Segment style={{ textAlign: "center" }}>
                                <Header>Tenant Signature</Header>
                                {!this.state.tenantPresent && <span> Change tenant to present to enable signature</span>}
                                {this.state.tenantPresent && <React.Fragment>
                                    {!this.state.trimmedImage && <div> <ReactSignatureCanvas penColor='black'
                                        canvasProps={{ className: 'sigCanvas' }} clearOnResize={this.state.clearOnResize} ref={(ref) => { this.sigPad = ref }} />
                                        <p className={"pad-top"} ><Button onClick={() => { canvasClear() }}>Clear</Button><Button primary onClick={() => { trimImage() }}>Accept</Button></p>
                                        <p>If you change phone orientation, click clear to recalibrate signature</p>
                                    </div>}
                                    {this.state.trimmedImage && <div ><Image style={{ margin: "auto", border: "1px solid gray", borderRadius: "10px" }} src={this.state.trimmedImage}></Image>
                                        <p className={"pad-top"}><Button onClick={() => { this.setState({ trimmedImage: null }) }}>Redo</Button></p>
                                    </div>}</React.Fragment>}</Segment>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}>
                             <Segment style={{ textAlign: "center", overflow: "auto" }}>
                                <Header>Preview - Can Scroll Horizontally On Mobile</Header>
                                {this.state.initialized &&<div style={{ minWidth: "600px", padding: "10px", textAlign: "center", maxWidth: "800px", margin: "auto" }}>
                                    <Table celled id="domGen" className="soc-table" compact="very" size="small" unstackable structured textAlign="center">
                                        <Table.Body>
                                            <Table.Row>
                                                <Table.Cell width={2}><strong>Property Address</strong></Table.Cell>
                                                <Table.Cell colSpan={5}>{this.state.propertyAddress}</Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell className="header-active" ><strong>Date Of Inspection</strong></Table.Cell>
                                                <Table.Cell>{this.state.dateOfInspection}</Table.Cell>
                                                <Table.Cell  className="header-active"><strong>Inspection Type</strong></Table.Cell>
                                                <Table.Cell>{this.state.inspectionType}</Table.Cell>
                                                <Table.Cell className="header-active"><strong>Tenant Present:</strong></Table.Cell>
                                                <Table.Cell >{this.state.tenantPresent ? "Present" : "Not Present"}</Table.Cell>                                              
                                            </Table.Row>
                                            <Table.Row >
                                                <Table.Cell></Table.Cell>
                                                {cleanlinessArr.map((cat) => { return<Table.Cell key={cat}className="header-active"><strong>{cat}</strong></Table.Cell> })}
                                            </Table.Row>
                                            {categoriesArr.map((category) => {
                                                return <Table.Row key={category}>
                                                    <Table.Cell width={2}><strong>{category}</strong></Table.Cell>
                                                    {cleanlinessArr.map((clean) => { return <Table.Cell key={category + clean} width={2}>{this.state.categories[category][clean].checked ? "X": null}{this.state.categories[category][clean].comment ? "- " + this.state.categories[category][clean].comment : null} </Table.Cell> })}
                                                </Table.Row>
                                            })}
                                            <Table.Row>
                                                <Table.Cell><strong>Additional Comments</strong></Table.Cell>
                                                <Table.Cell colSpan={5}>{this.state.additionalComments}</Table.Cell>
                                            </Table.Row>
                                            {this.state.tenantPresent && <React.Fragment>
                                                <Table.Row>
                                                    <Table.Cell colSpan={6} ><strong>Tenant Signature</strong></Table.Cell>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell className="socSig" colSpan={6}><Image className="soc-table-image" src={this.state.trimmedImage} /></Table.Cell>
                                                </Table.Row>
                                            </React.Fragment>}
                                        </Table.Body>
                                    </Table>
                                </div>}
                                {!this.state.initialized && <Button onClick={() => { this.setState({ initialized: true, generatedSOCImage:null })}}>Generate Table</Button>}
                            </Segment>
                            
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Segment style={{textAlign:"center"}}>
                                {this.state.initialized && <React.Fragment><Button loading={this.state.generatingCanvas} primary compact onClick={() => { generateSOCImage() }}>Generate SOC Image</Button> {this.state.generatedSOCImage && <React.Fragment><Button compact onClick={() => { saveImage() }}>Save Image</Button>{this.props.reportDetails && <Button compact onClick={() => { this.props.useImage(this.state.generatedSOCImage) }}>Use Image In Report</Button>}</React.Fragment>}
                                    <Image style={{ margin: "auto", maxWidth: "100%" }} className={"pad-top"} src={this.state.generatedSOCImage} />
                                </React.Fragment>}</Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Form>
      </Segment>
  }
}




// WEBPACK FOOTER //
// ./src/views/report/soc_generator/schedule_of_conditions_generator.js